import React, { useCallback, useEffect, useState } from 'react'
import { useBoolean } from "@fluentui/react-hooks";
import { DefaultButton, FontIcon, Panel, PanelType, PrimaryButton, TextField } from '@fluentui/react';
import { PanelHeader } from '../../../../components/Panel/PanelHeader';
import { MensajeBar } from '../../../../components/generic/ManejoResponseMessage/MessageBar';
import IdicadorProgress from '../../../../components/generic/IndicadorProgress';
import { IActualizarEquipoIperc } from '../../../../Interfaces/IPERC/IEquipo';
import { IResponsePost } from '../../../../Interfaces/base/IResponse';
import EquipoService from '../../../../services/Iperc/EquipoService';

export const PanelActualizarEquipoIperc = (props: any) => {

    const [response, setResponse] = useState<IResponsePost>(null!);
    const [isSend, { setTrue: onEnviar, setFalse: onCancelar }] =
        useBoolean(false);

    const [equipo, setEquipo] =
        useState<IActualizarEquipoIperc>({
            EquipoId: "",
            Nombre: ""
        });

    const [newNombre, setNewNombre] = useState("");

    const [disableBtn, setDisableBtn] = useState(true);

    const onChangeTextField = (
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue?: string,
        EquipoId?: string
    ) => {
        if (event !== undefined) {
            if (newValue !== undefined) {
                if (EquipoId) {
                    // setEquipo((prev) => ({
                    //     ...prev,
                    //     Nombre: newValue,
                    // }));
                    // setEquipo({
                    //     TipoEquipoId: TipoEquipoId,
                    //     Nombre: newValue,
                    // });
                    if (equipo.Nombre != newValue) {
                        setDisableBtn(false)
                    }
                    else {
                        setDisableBtn(true)
                    }
                    setNewNombre(newValue)
                }
            }
        }
    };

    const actualizarEquipo = () => {
        ocultarMensaje();
        onEnviar();
        const objActualizarEquipo: IActualizarEquipoIperc = { ...equipo }
        // objActualizarEquipo.EquipoId = "newNombre"
        objActualizarEquipo.Nombre = newNombre
        EquipoService.postActualizarNombreEquipo(objActualizarEquipo)
            .then((res) => {
                if (res.status === 200) {
                    setResponse(res.data);
                    // setResponse({
                    //     codigoMensaje: 1,
                    //     mensaje: "Actualización realizada",
                    // });

                    //loadTabla()

                    if (res.data?.codigoMensaje == 1) {
                        props.onDismiss();
                        props.onRefreshTable();
                    }
                    onCancelar();

                }
                else {
                    setResponse({
                        codigoMensaje: 3,
                        mensaje: "Actualización no realizada",
                    });
                }
                onCancelar();
            })
            .catch((err) => {
                setResponse({
                    codigoMensaje: 3,
                    mensaje: "Error al realizar la actualización",
                });
                onCancelar();
            });
    };

    const ocultarMensaje = () => {
        setResponse(null!);
    };


    const onRenderFooterPanel = useCallback(
        () => (
            <>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        justifyItems: "center",
                        height: "5%",
                        padding: "2opx",
                        margin: "20px",
                    }}
                >
                    <div style={{ display: "flex" }}>
                        <PrimaryButton disabled={disableBtn} onClick={() => actualizarEquipo()} text="Guardar" />
                    </div>
                    <div style={{ display: "flex" }}>
                        <DefaultButton
                            onClick={() => {
                                props.onDismiss();
                            }}
                            text={"Salir"}
                        />
                    </div>
                </div>
            </>
        ),
        [props.onDismiss, actualizarEquipo, disableBtn]
    );
    const onRenderHeaderPanel = useCallback(
        () => (
            <>
                <PanelHeader
                    key={"editar"}
                    nameIconHeader="Edit"
                    subTextHeader="Editar el Nombre del Equipo"
                    textHeader="Equipo"
                />
            </>
        ),
        []
    );



    useEffect(() => {
        if (props.isOpen) {
            setEquipo(props.modelActualizarEquipo);
            setNewNombre(props.modelActualizarEquipo?.Nombre || "");
            setDisableBtn(true);
        }
    }, [props.isOpen, props.modelActualizarEquipo]);

    useEffect(() => {
        if (!props.isOpen) {
            ocultarMensaje();
        }
    }, [props.isOpen]);


    return (
        <>

            <Panel
                isOpen={props.isOpen}
                onDismiss={props.onDismiss}
                isFooterAtBottom={true}
                onRenderHeader={onRenderHeaderPanel}
                onRenderFooter={onRenderFooterPanel}
                closeButtonAriaLabel="Close"
                type={PanelType.smallFixedFar}
                isLightDismiss
            >
                {/* <pre>{JSON.stringify("--------exsisteEquipo---", null, 2)}</pre>
                <pre>{JSON.stringify(props.modelActualizarEquipo, null, 2)}</pre>
                <pre>{JSON.stringify(newNombre, null, 2)}</pre> */}
                <MensajeBar
                    response={response}
                    ocultar={() => {
                        ocultarMensaje();
                    }}
                />

                {isSend === true ? (
                    <>
                        <IdicadorProgress
                            isSend={isSend}
                            subText="Espere un momento..."
                        />
                    </>
                ) : (
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-lg12">
                            <br />
                            <TextField
                                label="Nombre de Equipo:"
                                value={newNombre}
                                onChange={(e, value) =>
                                    onChangeTextField(e, value, props.modelActualizarEquipo?.EquipoId)
                                }
                                onRenderPrefix={(arg) => (
                                    <FontIcon
                                        iconName="Rename"
                                    //style={{ color: COLORES.Bases.primary }}
                                    />
                                )}
                                placeholder="Nombre de Equipo *"
                            />
                        </div>
                    </div>
                )}
            </Panel>
        </>
    )
}
